import { useSelector } from "react-redux";
import { getActiveFeatures } from "../redux/userSlice";

/** The dealer feature flag that gates Review Max (`dealers/{uid}/info/activeFeatures`). */
export const REVIEW_MAX_FEATURE = "reviewMax";

/**
 * True when this dealership has Review Max switched on.
 *
 * Only the *review request* half of the sold flow is gated on it — marking a
 * lead / car as sold and logging the deal is available to every dealership.
 */
const useReviewMaxEnabled = (): boolean => {
  const activeFeatures = useSelector(getActiveFeatures);
  return Array.isArray(activeFeatures) && activeFeatures.includes(REVIEW_MAX_FEATURE);
};

export default useReviewMaxEnabled;
